// extracted by mini-css-extract-plugin
module.exports = {"button":"_2fnpB","clickableArea":"_1GeKU","icon":"_3iWSW","facebook":"_15MvK","twitter":"_169kO","linked-in":"_1lEnJ","linkedIn":"_1lEnJ"};